import PropTypes from 'prop-types';
import closeButtonUrl from './close-button.svg';

export const YOU_CLOSE_ICON_URL = closeButtonUrl;

export const YouCloseIcon = ({ size = 24, alt = '' }) => (
  <img
    src={closeButtonUrl}
    alt={alt}
    width={size}
    height={size}
    data-testid="you-close-icon"
  />
);

YouCloseIcon.propTypes = {
  size: PropTypes.number,
  alt: PropTypes.string,
};

export default YouCloseIcon;
